import Keycloak from 'keycloak-js';
import store from '../vuex';
import main_api_axios from '../axios/main_api_axios';
import jsonwebtoken from 'jsonwebtoken';
import router from '../../router';
import {
  localeValueToKeyMap,
  localeKeyToValueMap
} from '@/assets/js/multilingual-tools';
import getQueryVariable from '@/assets/js/getQuery';

let installed = false;
let AuthManage;
export const navigationGuard = async (to, _from, next) => {
  if (to.meta.requiresAuth) {
    // We wait for Keycloak init, then we can call all methods safely
    while (!AuthManage || (AuthManage && AuthManage.createLoginUrl === null)) {
      await new Promise((resolve) => setTimeout(resolve, 100));
    }

    // track the originalUri for guardSecureRoute

    // guard the secure route based on the authState when enter
    const isAuthenticated = AuthManage.authenticated;
    if (!isAuthenticated) {
      AuthManage.login();
      return false;
    }
  }
  next();
  return true;
};

async function meTeam() {
  try {
    const teamId = window.localStorage.getItem('teamId');
    if (!teamId) {
      const res = await main_api_axios(
        'get',
        't/teams',
        { page: 0, size: 1 },
        true
      );
      const content = res.data.content;
      if (content.length) {
        store.commit('set_team', content[0]);
        window.localStorage.setItem('teamId', content[0].id);
        me();
      } else {
        window.VM.$Spin.hide();
        router.replace('/401');
      }
    } else {
      me();
    }
  } catch (error) {
    window.VM.$Spin.hide();
    AuthManage.logoutFn();
  }
}
async function me() {
  try {
    let res = await main_api_axios(
      'get',
      'mobile/employees/self',
      { needAuth: true },
      true
    );
    const localeKey =
      getQueryVariable('i18n') || localeValueToKeyMap[res.data.language];
    switchLanguage(localeKey);
    if (
      !res.data.hasUserPermission &&
      location.pathname !== '/authorization-callback'
    ) {
      router.replace('/401');
      window.VM.$Spin.hide();
      return;
    }
    const user = jsonwebtoken.decode(AuthManage.token);
    user.passport = user.sub;
    res.data.user = user;
    localStorage.setItem('self', JSON.stringify(res.data));
    store.commit('set_self', res.data);
    if (location.pathname === '/') {
      router.replace('/dashboard');
    }
    window.VM.$Spin.hide();
  } catch (error) {
    window.VM.$Spin.hide();
    if (error && error.data.code !== 402 && error.data.code !== 1001) {
      AuthManage.logoutFn();
    } else if (error.data.code === 1001) {
      // 跳转“找不到页面”页面
      router.replace('/approverError?type=notFound');
    }
  }
}
// 切换语言
function switchLanguage(key) {
  if (key) {
    const i18nValue = localStorage.getItem('i18n');
    if (key !== i18nValue) {
      // 语言不同时，执行同步，以用户语言为主
      switchUserLanguage(key);
    }
  }
}
async function switchUserLanguage(key) {
  try {
    localStorage.setItem('i18n', key);
    await main_api_axios(
      'post',
      'mobile/user_language',
      { language: localeKeyToValueMap[key] },
      false
    );
    location.reload();
  } catch (e) {
    console.log(e);
  }
}
function install(app, params = {}) {
  if (installed) return;
  installed = true;

  const defaultParams = {
    config: window.__BASEURL__ ? `${window.__BASEURL__}/config` : '/config',
    init: { onLoad: 'login-required' }
  };
  const options = Object.assign({}, defaultParams, params);
  if (assertOptions(options).hasError)
    throw new Error(`Invalid options given: ${assertOptions(options).error}`);

  vue2AndVue3Reactive(app, defaultEmptyVueKeycloakInstance()).then((watch) => {
    getConfig(options.config)
      .then((config) => {
        initFn(config, watch, options);
      })
      .catch((err) => {
        console.log(err);
      });
  });
}

function defaultEmptyVueKeycloakInstance() {
  return {
    ready: false,
    authenticated: false,
    userName: null,
    fullName: null,
    token: null,
    tokenParsed: null,
    logoutFn: null,
    loginFn: null,
    login: null,
    createLoginUrl: null,
    createLogoutUrl: null,
    createRegisterUrl: null,
    register: null,
    accountManagement: null,
    createAccountUrl: null,
    loadUserProfile: null,
    subject: null,
    idToken: null,
    idTokenParsed: null,
    realmAccess: null,
    resourceAccess: null,
    refreshToken: null,
    refreshTokenParsed: null,
    timeSkew: null,
    responseMode: null,
    responseType: null,
    hasRealmRole: null,
    hasResourceRole: null,
    keycloak: null,
    expiresAt: null
  };
}

function vue2AndVue3Reactive(app, object) {
  return new Promise((resolve, reject) => {
    if (app.prototype) {
      // Vue 2
      try {
        const reactiveObj = app.observable(object);
        Object.defineProperty(app.prototype, '$keycloak', {
          get() {
            return reactiveObj;
          }
        });
        AuthManage = reactiveObj;
        resolve(reactiveObj);
      } catch (e) {
        reject(e);
      }
    }
  });
}

function initFn(config, watch, options) {
  const keycloak = new Keycloak(config);

  keycloak.onReady = function (authenticated) {
    updateWatchVariables(authenticated);
    watch.ready = true;
    typeof options.onReady === 'function' && options.onReady(keycloak, watch);
  };
  keycloak.onAuthSuccess = function () {
    // Check token validity every 10 seconds (10 000 ms) and, if necessary, update the token.
    // Refresh token if it's valid for less then 60 seconds
    const updateTokenInterval = setInterval(
      () =>
        keycloak.updateToken(60).catch(() => {
          keycloak.clearToken();
        }),
      10000
    );
    watch.logoutFn = () => {
      clearInterval(updateTokenInterval);
      keycloak.logout(options.logout);
    };
  };
  keycloak.onAuthRefreshSuccess = function () {
    updateWatchVariables(true);
  };
  keycloak.onAuthRefreshError = function () {
    updateWatchVariables(false);
    typeof options.onAuthRefreshError === 'function' &&
      options.onAuthRefreshError(keycloak);
  };
  keycloak
    .init(options.init)
    .then((authenticated) => {
      updateWatchVariables(authenticated);
      typeof options.onInitSuccess === 'function' &&
        options.onInitSuccess(authenticated);
      if (authenticated) {
        meTeam();
      } else {
        window.VM.$Spin.hide();
      }
    })
    .catch((err) => {
      updateWatchVariables(false);
      const error = Error('Could not initialized keycloak-js adapter');
      typeof options.onInitError === 'function'
        ? options.onInitError(error, err)
        : console.error(error, err);
      window.VM.$Spin.hide();
    });

  function updateWatchVariables(isAuthenticated = false) {
    watch.authenticated = isAuthenticated;
    watch.loginFn = keycloak.login;
    watch.login = keycloak.login;
    watch.createLoginUrl = keycloak.createLoginUrl;
    watch.createLogoutUrl = keycloak.createLogoutUrl;
    watch.createRegisterUrl = keycloak.createRegisterUrl;
    watch.register = keycloak.register;
    watch.keycloak = keycloak;
    if (isAuthenticated) {
      watch.accountManagement = keycloak.accountManagement;
      watch.createAccountUrl = keycloak.createAccountUrl;
      watch.hasRealmRole = keycloak.hasRealmRole;
      watch.hasResourceRole = keycloak.hasResourceRole;
      watch.loadUserProfile = keycloak.loadUserProfile;
      watch.token = keycloak.token;
      watch.subject = keycloak.subject;
      watch.idToken = keycloak.idToken;
      watch.idTokenParsed = keycloak.idTokenParsed;
      watch.realmAccess = keycloak.realmAccess;
      watch.resourceAccess = keycloak.resourceAccess;
      watch.refreshToken = keycloak.refreshToken;
      watch.refreshTokenParsed = keycloak.refreshTokenParsed;
      watch.timeSkew = keycloak.timeSkew;
      watch.responseMode = keycloak.responseMode;
      watch.responseType = keycloak.responseType;
      watch.tokenParsed = keycloak.tokenParsed;
      watch.userName = keycloak.tokenParsed['preferred_username'];
      watch.fullName = keycloak.tokenParsed['name'];
      watch.expiresAt =
        keycloak.tokenParsed.exp +
        keycloak.timeSkew -
        new Date().getTime() / 1000;
    }
  }
}

function assertOptions(options) {
  const { config, init, onReady, onInitError, onAuthRefreshError } = options;
  if (typeof config !== 'string' && !_isObject(config)) {
    return {
      hasError: true,
      error: `'config' option must be a string or an object. Found: '${config}'`
    };
  }
  if (!_isObject(init) || typeof init.onLoad !== 'string') {
    return {
      hasError: true,
      error: `'init' option must be an object with an 'onLoad' property. Found: '${init}'`
    };
  }
  if (onReady && typeof onReady !== 'function') {
    return {
      hasError: true,
      error: `'onReady' option must be a function. Found: '${onReady}'`
    };
  }
  if (onInitError && typeof onInitError !== 'function') {
    return {
      hasError: true,
      error: `'onInitError' option must be a function. Found: '${onInitError}'`
    };
  }
  if (onAuthRefreshError && typeof onAuthRefreshError !== 'function') {
    return {
      hasError: true,
      error: `'onAuthRefreshError' option must be a function. Found: '${onAuthRefreshError}'`
    };
  }
  return {
    hasError: false,
    error: null
  };
}

function _isObject(obj) {
  return (
    obj !== null &&
    typeof obj === 'object' &&
    Object.prototype.toString.call(obj) !== '[object Array]'
  );
}

function getConfig(config) {
  if (_isObject(config)) return Promise.resolve(config);
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', config);
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          resolve(JSON.parse(xhr.responseText));
        } else {
          reject(Error(xhr.statusText));
        }
      }
    };
    xhr.send();
  });
}

export default { install };
export { AuthManage };
